<div
    [class]="'flex flex-col w-full md:flex-row justify-between p-2 rounded-lg  bg-mg-base-background ' + (taskInfo.editState ? 'border-2 border-mg-accent-light' : '')">
    <div class="flex flex-col gap-1.5">
        <div class="flex items-start gap-2 mb-2">
            <div class="bg-mg-accent-light flex items-center justify-center rounded-full">
                <mg-icon class="m-2" iconClass="text-mg-accent" iconName="schedule"></mg-icon>
            </div>
            <div>
                <div class="flex gap-2">
                    <div class="text-xs font-bold text-mg-accent">Fecha: </div>
                    <p class="text-xs text-mg-gray">{{ fechaVisible() }}</p>
                </div>
                <div class="flex gap-2">
                    <div class="text-xs font-bold text-mg-accent">Tipo de Hora: </div>
                    <p class="text-xs text-mg-gray">{{taskInfo.sNombre_Tipo_Horas}}</p>
                </div>
                <div class="flex gap-2">
                    <div class="text-xs font-bold text-mg-accent">Cant. Horas: </div>
                    <p class="text-xs text-mg-gray">{{taskInfo.nMinutos | hourPipe}}</p>
                </div>
            </div>
        </div>
        <div *ngIf="isProjectModuleActive" class="flex items-start gap-2 mb-2">
            <div class="bg-mg-accent-light flex items-center justify-center rounded-full">
                <mg-icon class="m-2" iconClass="text-mg-accent" iconName="assignment"></mg-icon>
            </div>
            <div>
                <div class="flex gap-2">
                    <div class="text-xs font-bold text-mg-accent">Proyecto: </div>
                    <p class="text-xs text-mg-gray">{{taskInfo.sNombre_Proyecto | titlecase}}</p>
                </div>
                <div class="flex gap-2">
                    <div class="text-xs font-bold text-mg-accent">RQ: </div>
                    <p class="text-xs text-mg-gray">{{taskInfo.sNombre_Requerimiento | titlecase}}</p>
                </div>
                <div class="flex gap-2">
                    <div class="text-xs font-bold text-mg-accent">Categoría: </div>
                    <p class="text-xs text-mg-gray">{{taskInfo.sNombre_Categoria | titlecase}}</p>
                </div>
            </div>
        </div>
        <div class="flex items-start gap-2">
            <div class="bg-mg-accent-light flex items-center justify-center rounded-full">
                <mg-icon class="m-2" iconClass="text-mg-accent" iconName="sticky_note_2"></mg-icon>
            </div>
            <div>
                <div class="text-xs font-bold text-mg-accent">Detalle: </div>
                <p class="text-xs text-mg-gray" style="overflow-wrap: anywhere;">
                    {{taskInfo.sDetalle}}</p>
            </div>
        </div>
        @if(taskInfo.sMensaje_Error){
        <mat-hint class="p-1 flex items-center justify-start gap-2 w-full bg-mg-danger-light rounded-xl">
            <mg-icon iconClass="text-xl text-mg-danger-dark" iconName="warning"></mg-icon>
            <div class="text-xs text-mg-danger-dark break-normal whitespace-pre-line">{{taskInfo.sMensaje_Error}}</div>
        </mat-hint>
        }
    </div>
    <div class="flex flex-col mt-2 md:mt-0 items-end md:items-center">
        <div *ngIf="!taskInfo.editState" class="flex md:flex-col gap-2 h-9">
            <div (click)="editTask()"
                class="bg-mg-main-blue-light border-mg-main-blue cursor-pointer flex items-center justify-center p-1.5 rounded-full w-fit">
                <mg-icon iconClass="text-mg-accent" iconName="edit"></mg-icon>
            </div>
            <div (click)="deleteTask()"
                class="bg-mg-red-light border-mg-red-dark cursor-pointer flex items-center justify-center p-1.5 rounded-full w-fit">
                <mg-icon iconClass="text-mg-red-dark" iconName="delete"></mg-icon>
            </div>
        </div>
    </div>
</div>